(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["split-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSplit(root) {
    if (!root || root.dataset.slInited) return;
    root.dataset.slInited = '1';

    var mode = root.dataset.mobile;
    var wrap = root.querySelector('.split-landing__wrap');
    var panels = root.querySelectorAll('.split-landing__panel');
    var inEditor = window.Shopify && window.Shopify.designMode;

    // Click a side -> go straight to the page. No animation; we just paint a full-screen cover in the
    // clicked side's own colour so the browser's page-load hand-off never flashes white.
    panels.forEach(function (p) {
      p.addEventListener('click', function (e) {
        var href = p.getAttribute('href');
        if (inEditor) { e.preventDefault(); return; }
        if (!href || href === '#') { e.preventDefault(); return; }
        e.preventDefault();
        // Remember which side they chose so a return visit skips straight back to that brand's home.
        try {
          var cfg = window.__bbSplitCfg;
          if (cfg) {
            var s = cfg.scope === 'persistent' ? window.localStorage : window.sessionStorage;
            if (s) { s.setItem('bbSplitBrand', href); }
          }
        } catch (err) {}
        var cover = document.createElement('div');
        var bg = p.style.getPropertyValue('--bg') || getComputedStyle(p).backgroundColor || '#111';
        cover.style.cssText = 'position:fixed;inset:0;z-index:99999;background:' + bg + ';';
        document.body.appendChild(cover);
        // Navigate after a paint so the cover is on screen before the current page unloads.
        requestAnimationFrame(function () { requestAnimationFrame(function () { window.location.href = href; }); });
      });
    });

    // Toggle mode
    if (mode === 'toggle') {
      var tabs = root.querySelectorAll('.split-landing__toggle button');
      var activate = function (i) {
        panels.forEach(function (p, x) { p.classList.toggle('is-active', x === i); });
        tabs.forEach(function (t, x) {
          var on = x === i;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      };
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { activate(i); }); });
      activate(0);
    }

    // Swipe mode dots
    if (mode === 'swipe' && wrap) {
      var dots = root.querySelectorAll('.split-landing__dots i');
      wrap.addEventListener('scroll', function () {
        var i = Math.round(wrap.scrollLeft / wrap.clientWidth);
        dots.forEach(function (d, x) { d.classList.toggle('is-on', x === i); });
      }, { passive: true });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.split-landing').forEach(initSplit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
